export default "__VITE_ASSET__CGSMFg5w__"